import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./NumbersModal.css";
import { UpdateScenarioCommand } from "../../api/api";
import ScenarioTimes from "../../constants/ScenarioTimes";
const ScenarioTimerModal = ({commands, setCommands}) => {
  const {
    setScenarioTimerModal,
    scenarioCommandDetail,
    setScenarioCommandDetail,
    setScenarioCommands,
    scenarioCommands,
    setIsLoading,
    scenarioTimeCondition,
    
  } = useContext(Context);
  const [timerValue, setTimerValue] = useState(null);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setScenarioTimerModal(modalName);
    setTimerValue(scenarioCommandDetail.time);
  }, [scenarioCommandDetail]);

  const handleChangeScenarioTime = () => {
  setCommands((prevCommands) =>
    prevCommands.map((command) =>
      command.id == scenarioCommandDetail.id
        ? {
            ...command,
            time: timerValue,
          }
        : command
    )
  );
    closeButton.current.click();
  };

  const renderTime = () => {
    return ScenarioTimes.map((item, index) => {
      if (scenarioTimeCondition.includes(item.value)) return;
      return (
        <option value={item.value ?? ""} key={index}>
          {item.name}
        </option>
      );
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              مدت تاخیر
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <select
                id="timerSelect"
                className="form-select w-100"
                data-style="btn-default"
                value={timerValue}
                onChange={(e) => setTimerValue(e.target.value)}
              >
                {renderTime()}
              </select>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleChangeScenarioTime}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioTimerModal;
